import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { connect } from "react-redux";
import { giveFeedback } from "../../../../store/actions/userActions";

class FeedbackModal extends Component {
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSubmit = () => {
    const { feedback, comment } = this.state;
    if (feedback === "" || comment === "") return;
    if (feedback.length > 1) {
      alert("Rate out of 5 please.");
      return;
    }
    const { id, service } = this.props;
    this.props
      .giveFeedback({ id, service, feedback, comment })
      .then((res) => {
        if (res) {
          alert("Feedback submitted successfully!");
          this.props.hide();
        }
      })
      .catch((e) => alert(e.message));
  };
  render() {
    const myBtn = {
      background: "transparent",
      padding: "0 2rem",
      fontSize: "1rem",
      boxShadow: "none",
      border: "1px solid #4ec8a3",
      color: "#4ec8a3",
      height: "3rem",
    };
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.hide}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title className="px-lg-4">Feedback</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "2rem" }}>
          <Form>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Your Feedback</Form.Label>
              <Form.Control
                type="number"
                maxLength={1}
                placeholder="Rate from 5"
                name="feedback"
                onChange={this.handleChange}
              />
            </Form.Group>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Comment</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                name="comment"
                onChange={this.handleChange}
              />
            </Form.Group>
          </Form>
          <Row className="justify-content-start mt--20">
            <button
              className="ar-button style-flat mr--20"
              style={myBtn}
              onClick={this.onSubmit}
            >
              <span className="button-text">Submit</span>
            </button>
            <button
              className="ar-button style-flat mr--20"
              style={myBtn}
              onClick={this.props.hide}
            >
              <span className="button-text">Cancel</span>
            </button>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    giveFeedback: (data) => dispatch(giveFeedback(data)),
  };
};
export default connect(null, mapDispatchToProps)(FeedbackModal);
